// @flow

import type { CheckoutPaymentOptionsV2, OpenedIncomingPayment } from './types';
import type { PaymentOption } from './payment-option';
import { getCheckoutPaymentOptionsV2 } from '@tectonics/prs/incoming-payment/get-checkout-payment-options';

export function getSafePaymentOptions(incomingPayment: OpenedIncomingPayment): ImmutableArray<PaymentOption> {
  const paymentOptions = incomingPayment['payment_options'];
  if(!paymentOptions)
    throw new Error('Payment Options: no payment options for opened payment');

  return paymentOptions;
}

export function getSafePaymentOptionsV2(incomingPayment: OpenedIncomingPayment): ImmutableArray<PaymentOption> | CheckoutPaymentOptionsV2 {
  let checkoutPaymentOptions = getCheckoutPaymentOptionsV2(incomingPayment);
  if (checkoutPaymentOptions) {
    return checkoutPaymentOptions;
  }

  return getSafePaymentOptions(incomingPayment);
}
